import { render, staticRenderFns } from "./GtInit.vue?vue&type=template&id=bc812e86&"
import script from "./GtInit.vue?vue&type=script&lang=ts&"
export * from "./GtInit.vue?vue&type=script&lang=ts&"
import style0 from "./GtInit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports